import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

interface EngagementHubV2ProfileProps {
  multiUser: boolean
}
const useStyles = makeStyles<Theme, EngagementHubV2ProfileProps>(theme => ({
  root: {
    backgroundColor: 'white',
    height: 88,
    display: 'grid',
    gridTemplateColumns: 'auto minmax(50px, 1fr) auto',
    alignItems: 'center',
    borderBottom: 'solid 1px lightgrey',

    [theme.breakpoints.down('md')]: {
      height: 96,
      borderBottom: '0px'
    }
  },

  avatarRoot: {
    display: 'flex'
  },

  avatar: {
    '& .avatar': {
      height: 48,
      width: 48,
      marginLeft: 24,
      marginRight: 16
    },

    '& span:nth-child(2)': {
      right: '26%'
    }
  },

  nameRoot: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: ({ multiUser }) =>
      multiUser ? `minmax(20px, min-content) minmax(24px, auto)` : `1fr`
  },

  name: {
    display: 'inline-block',
    color: '#121212',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontSize: theme.size.lg,
    cursor: 'default',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },

  menuRoot: {
    display: 'inline-block',
    marginRight: '1rem'
  }
}))

export default useStyles
